{
  "hello": "Bonjour",
  "booking": {
    "label": "Réservation"
  },
  "service": {
    "duration": "Durée",
    "price": "Prix",
    "book_now": "Réserver maintenant"
  },
  "action": {
    "back_home": "Retour à l'accueil",
    "try_again": "Réessayer"
  },
  "gift-card": {
    "select-amount": "Quel montant souhaitez-vous ?",
    "amount": "Montant",
    "custom-amount": {
      "label": "Ou entrez un montant personnalisé",
      "placeholder": "Entrez un montant",
      "hint": "Le montant doit être supérieur à 0"
    },
    "service-price-indicator": "Ce montant correspond au prix d'un soin",
    "from-name": {
      "label": "De la part de",
      "placeholder": "Votre nom"
    },
    "to-name": {
      "label": "À destination de",
      "placeholder": "Nom du destinataire"
    },
    "message": {
      "label": "Message",
      "placeholder": "Écrivez un message personnalisé (optionnel)"
    },
    "proceed-to-checkout": "Confirmer",
    "info": "Information du bon cadeau",
    "summary": "Récapitulatif",
    "item": {
      "label": "Carte cadeau de {amount} €"
    }
  },
  "checkout": {
    "coordinates": {
      "label": "Vos coordonnées"
    },
    "payment": {
      "confirm": "Procéder au paiement",
      "in_progress": "En cours de traitement...",
      "error_initializing": "Erreur lors de l'initialisation du paiement. {error}",
      "feedback": {
        "success": {
            "title": "Paiement réussi !",
            "message": "Merci pour votre achat. Un e-mail de confirmation vous a été envoyé."
        },
        "pending": {
            "title": "Paiement en attente",
            "message": "Votre paiement est en cours de traitement. Nous vous enverrons une confirmation par e-mail une fois terminé."
        },
        "error": {
          "title": "Échec du paiement",
          "message": "Une erreur est survenue lors du traitement de votre paiement."
        },
        "unknown": {
          "title": "Une erreur est survenue",
          "message": "Impossible de déterminer le statut du paiement."
        },
        "waiting": {
          "title": "Vérification du paiement",
          "message": "Veuillez patienter pendant que nous vérifions le statut de votre paiement."
        }
      }
    },
    "transaction": {
      "label": "Transaction {paymentId} du {date}",
      "pending": "Vérification du paiement en cours..."
    }
  },
  "nav": {
    "gift-card": "Offrir un bon cadeau",
    "booking": "Réserver un soin",
    "home": "Accueil",
    "qui-suis-je": "Qui suis-je ?",
    "soins": "Carte des soins",
    "mes-marques": "Mes marques"
  },
  "seo": {
    "title": "Esthéticienne & Kératothérapeute – ClemKerato",
    "offerCatalogName": "Skin Glow Expert - Kératothérapeute® - Expertise de la peau"
  },
  "instagram_feed": {
    "title": "Mon univers sur Insta"
  }
}